import { StrictMode } from "@bestowinc/tinkertoy-shell-deps/react";
import { createRoot } from "react-dom/client";

import {
  markShellBootstrapStart,
} from "./performance-telemetry";
import type { ShellConfig } from "./router/types";
import { ShellRoot } from "./ShellRoot";

/**
 * Mount the shell into a DOM node (browser app entry, Storybook, unit tests, module harnesses).
 */
export function mountShell(container: HTMLElement, config: ShellConfig): void {
  markShellBootstrapStart();
  createRoot(container).render(
    <StrictMode>
      <ShellRoot config={config} />
    </StrictMode>,
  );
}
